export default __webpack_public_path__ + "7a74b8af2e56c982a0670b79d26ae73a.png";